import styled, { useTheme } from 'styled-components';
import useTestAddPageController from '../../1_application/test/testAddPageController';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import { XCenter } from '../core/components/center';
import LXStep from '../core/components/step/lxStep';
import { LXh2 } from '../core/texts/lxText';
import TestAddClientSelectList from './components/testAddClientSelectList';
import TestAddOverView from './components/testAddOverview';
import TestAddSideBar from './components/testAddSideBar';
import TestAddStaff from './components/testAddStaff';
import TestAddTestItemSelectList from './components/testAddTestItemSelectList';

const SelectorContainer = styled.div`
  flex-grow: 1;
  border-radius: 12px;
  padding: 30px;
  background-color: ${(props) => props.theme.colors.white};
`;

const TestAddPage = () => {
  const theme = useTheme();
  const c = useTestAddPageController();

  const buildProperStepSelector = () => {
    if (c.step === 0) {
      return (
        <SelectorContainer>
          <TestAddClientSelectList
            client={c.client}
            onClientSelect={c.setClient}
          ></TestAddClientSelectList>
        </SelectorContainer>
      );
    } else if (c.step === 1) {
      return (
        <SelectorContainer>
          <TestAddTestItemSelectList
            testCategories={c.testCategories}
            testItems={c.testItems}
            addTestItem={c.addTestItem}
            removeTestItem={c.removeTestItem}
          ></TestAddTestItemSelectList>
        </SelectorContainer>
      );
    } else if (c.step === 2) {
      return (
        <SelectorContainer>
          <TestAddStaff
            memo={c.memo}
            onMemoChange={c.setMemo}
            receptionist={c.receptionist}
            attendingPhysician={c.attendingPhysician}
            setReceptionist={c.setReceptionist}
            setAttendingPhysician={c.setAttendingPhysician}
          ></TestAddStaff>
        </SelectorContainer>
      );
    } else {
      return (
        <SelectorContainer>
          <TestAddOverView
            onPrev={c.onPrev}
            onSave={c.saveTest}
            client={c.client!}
            receptionist={c.receptionist!}
            attendingPhysician={c.attendingPhysician!}
            testItems={c.testItems}
            memo={c.memo}
          ></TestAddOverView>
        </SelectorContainer>
      );
    }
  };

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXh2>{theme.texts.newTest}</LXh2>
        <SizedBox height={40}></SizedBox>
        <LXStep
          width={467}
          current={c.step}
          titles={[
            theme.texts.client,
            theme.texts.testItem,
            theme.texts.manager,
            theme.texts.confirm,
          ]}
        ></LXStep>
        <SizedBox height={30}></SizedBox>
        <Row width="960px" alignItems="flex-start">
          {buildProperStepSelector()}
          {c.buildSider && <SizedBox width={16}></SizedBox>}
          {c.buildSider && (
            <TestAddSideBar
              client={c.client}
              testItems={c.testItems}
              receptionist={c.receptionist}
              attendingPhysician={c.attendingPhysician}
              removeTestItem={c.removeTestItem}
              onNext={c.onNext}
              onPrev={c.onPrev}
              isFirstStep={c.step === 0}
              nextDisabled={c.nextDisabled}
            ></TestAddSideBar>
          )}
        </Row>
      </Column>
    </XCenter>
  );
};

export default TestAddPage;
